import { client } from "../supabase";

/**
 * Batch del saldo aplicado por target desde el libro `pagos_capex`. UNA sola query por país (evita
 * N+1, 10.234). Molde de `getSaldosRecibidasPorFactura` (proveedor).
 *
 * Devuelve Map<`${target_tipo}:${target_id}`, { aplicadoTarget, nEventos, moneda }>, donde
 * aplicadoTarget = Σ `monto_target` de los eventos VIGENTES (reversado_at IS NULL) — la unidad EXACTA
 * del saldo (moneda del target). El consumidor (Fase 2) hace `computarSaldoCapex(objetivo, aplicadoTarget)`
 * (misma fórmula que getSaldoCapexTarget, 10.1). NO se resta acá porque el objetivo vive en lote_costos /
 * plan_pagos_activos, no en el libro (una query, como pidió la Fase 1).
 *
 * NO wireada a los loaders todavía (eso es Fase 2). Existe para la verificación de Fase 1 y su consumo.
 *
 * Volumen: un evento por target saldado (hoy 41). Muy por debajo del techo de filas del server (10.167);
 * si algún día supera ~1000, paginar con .range().
 */
export const claveTargetCapex = (targetTipo, targetId) => `${targetTipo}:${targetId}`;

export const getSaldosCapexPorTarget = async (pais) => {
  const map = new Map();
  if (!pais) return map;
  const { data, error } = await client
    .from("pagos_capex")
    .select("target_tipo, target_id, monto_target, moneda")
    .eq("pais", pais)
    .is("reversado_at", null);
  if (error) throw error;
  for (const e of data || []) {
    const k = claveTargetCapex(e.target_tipo, e.target_id);
    const acc = map.get(k) || { aplicadoTarget: 0, nEventos: 0, moneda: e.moneda };
    acc.aplicadoTarget += Number(e.monto_target || 0);
    acc.nEventos += 1;
    map.set(k, acc);
  }
  return map;
};
